import { VerifiedUser } from '@mui/icons-material';
import { Box, styled, SxProps, Typography, TypographyStyle, useTheme } from '@mui/material';

export const CredentialsVerifiedProfileBadge: React.FC<{
  sx: SxProps;
  fontSx: TypographyStyle;
}> = ({ sx, fontSx }) => {
  const theme = useTheme();

  return (
    <Container sx={sx}>
      <VerifiedUser sx={{ color: theme.palette.primary.main }} />
      <Typography
        sx={{
          fontSize: theme.typography.body2.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.secondary,
          ...fontSx,
        }}
      >
        Credentials Verified
      </Typography>
    </Container>
  );
};

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.875), // 7px, to stay consistent with nudges display
}));
